import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { initializeCloudflareAnalytics } from './utils/cloudflareAnalytics'
import { safeArea } from './utils/mobileUtils'

initializeCloudflareAnalytics()

// Initialize mobile utilities
safeArea.initialize();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
